import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { OpalApiResponseDocument, OpalApiRequestParams } from '../../../schema'
import { blocks } from '../../../v3/blocks'
import { globalQueryKeys } from '../../queryKeys'

type BlocksResponse = OpalApiResponseDocument<'ReadBlocksV3', 200>
type ReadBlocksParams<TSelectedData> = UseQueryOptions<
  BlocksResponse,
  unknown,
  TSelectedData
> & {
  query: OpalApiRequestParams<'ReadBlocksV3'>['query']
  workspaceId: string
}

export const useReadBlocksV3 = <TSelectedData = BlocksResponse>({
  query,
  select,
  workspaceId,
}: ReadBlocksParams<TSelectedData>) => {
  return useQuery({
    queryKey: globalQueryKeys.blocksByWorkspace(workspaceId, query),
    queryFn: () =>
      blocks.readCollection({
        params: {
          query,
        },
      }),
    retry: false,
    useErrorBoundary: true,
    select,
  })
}
